import { Box, Button, Modal, Text } from '@fozito/common-ui';
import { FooterActions } from 'modules/POS/Cashier/components/styles';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
type Props = {
};
type Configs = {
  title?: string;
  message?: string;
};
type Ref = {
  open: (callback: () => void, configs?: Configs) => void;
};
export const globalModalConfirmRef = React.createRef<Ref>();
export const alertConfirm: Ref['open'] = (cb, type) => globalModalConfirmRef.current?.open(cb, type);
export const useModalConfirmRef = () => useRef<Ref>(null);
const ModalConfirm = forwardRef<Ref, Props>(({ }, ref) => {
  const [configs, setConfigs] = useState<Configs | null>(null);
  const callbackRef = useRef<() => void>(() => undefined);
  const [open, setOpen] = useState<boolean>(false);
  const onClose = () => setOpen(false);
  const onOpen: Ref['open'] = async (cb, _configs) => {
    setConfigs(_configs || null);
    callbackRef.current = cb;
    setOpen(true);
  };

  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  const handleDone = () => {
    onClose();
    callbackRef.current();

  };
  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal title={configs?.title || 'Please Confirm'} open={!!open} onClose={onClose} width={700} onOk={handleDone}>
      <Box display='flex' padding={24} textAlign='center' justifyContent='center' gap={4}>
        <Text title_h6_20_regular>{configs?.message || 'Do you like to create the ticket'} </Text>
      </Box>
      <FooterActions>
        <Button style={{ flex: 1 }} onClick={handleCancel} type_cancel><span>Close</span></Button>
        <Button style={{ flex: 1 }} onClick={handleDone} type_primary><span>OK</span></Button>
      </FooterActions>
    </Modal>
  );
});

ModalConfirm.displayName = 'ModalConfirm';

export default ModalConfirm;